import cn from "classnames";
import { forwardRef, InputHTMLAttributes } from "react";
import ExclamationIcon from "../icons/exclamation";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  onChange?: (...args: any[]) => any;
  error?: string;
  srOnly?: boolean;
}

const Input = forwardRef<HTMLInputElement, Props>((props, inputRef) => {
  const {
    className,
    children,
    id,
    label,
    onChange,
    type,
    error,
    srOnly,
    ...rest
  } = props;
  const rootClassName = cn(
    "bg-gray-700 block w-full rounded-md text-sm text-gray-400 hover:bg-gray-600 focus:bg-gray-600 focus:text-gray-50",
    error
      ? "border-red-500 focus:outline-none focus:ring-red-500 focus:border-red-500"
      : "border-gray-600 focus:ring-indigo-500 focus:border-indigo-500",
    className
  );

  return (
    <div>
      <label
        htmlFor={id}
        className={
          srOnly ? "sr-only" : "block text-sm text-gray-400 capitalize"
        }
      >
        {label || rest.name}
      </label>
      <div className={`${!srOnly ? "mt-1" : ""} relative`}>
        {!!error && error === "required" && (
          <div className="absolute -top-6 right-0">
            <span className="text-xs font-medium text-red-500 uppercase">
              Required
            </span>
          </div>
        )}
        <input
          id={id}
          ref={inputRef}
          className={rootClassName}
          onChange={onChange}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          type={type || "text"}
          {...rest}
        />
        {!!error && !error.includes("required") && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationIcon className="h-5 w-5 text-red-500" />
          </div>
        )}
      </div>
      {!!error && !error.includes("required") && (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
});

Input.displayName = "Input";

export default Input;
